import { create } from 'zustand';

import type { PlanFeature } from '@/types/plan-access';
import { parsePlanFeatureLocked } from '@/utils/plan-access';

interface PlanFeatureState {
  feature: PlanFeature | null;
  close: () => void;
}

/** Aviso de "assine para liberar", montado uma vez no layout raiz. */
export const usePlanFeatureStore = create<PlanFeatureState>((set) => ({
  feature: null,
  close: () => set({ feature: null }),
}));

export function showPlanFeature(feature: PlanFeature): void {
  usePlanFeatureStore.setState({ feature });
}

/**
 * Abre o aviso quando o erro é a trava do plano. Devolve `true` para o call
 * site pular o próprio toast — um feedback só.
 */
export function showPlanFeatureFromError(err: unknown): boolean {
  const feature = parsePlanFeatureLocked(err);
  if (!feature) return false;
  showPlanFeature(feature);
  return true;
}
